<template>
  <div>
    <sweet-modal blocking :title="title" ref="modal" class="modal" v-on:close="closeModal('component')">
      <!-- <div v-if="isCreate">You see Item types, based on settings in you company type settings “ORGANISATION INFORMATION"</div> -->

      <el-alert
        v-if="isCreate"
        title='Item types listed are based on your company settings. Refer "ORNANISATION INFORMATION"'
        type="info">
      </el-alert>

      <el-row :gutter="20">
        <el-col :span="6" :offset="0">
          <el-select :disabled="!isCreate" v-model="typeId" placeholder="Item Type" filterable clearable style="width: 100%; margin-bottom: 20px;" @change="selectType">
            <el-option v-for="item in itemTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <!-- <keep-alive> -->
        <component :is="currentTabComponent" ref="component" :typeId="typeId" @loadList="() => this.$emit('loadList')" @modalCancel="modalCancel"></component>
      <!-- </keep-alive> -->
    </sweet-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Main from '@/components/settings/items/modal/Main.vue'
  import Service from '@/components/settings/items/modal/Service.vue'
  import Inventory from '@/components/settings/items/modal/Inventory.vue'
  import Group from '@/components/settings/items/modal/Group.vue'

  export default {
    name: 'create-update-modal',
    components: {
      SweetModal,
      Main,
      Service,
      Inventory,
      Group,
    },
    props: {
      itemTypeList: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        title: '',
        isCreate: true,
        row: null,
        onlyInfo: false,

        typeId: null,
        group: {
          0: 'Main',
          1: 'Service',
          2: 'Inventory',
          3: 'Group',
          4: 'Service'
        },
        currentTabComponent: 'Main',
      }
    },
    methods: {
      setTitle() {
        if (this.onlyInfo) {
          this.title = 'Item Details'
        } else {
          this.title = this.isCreate ? 'Add Item' : 'Edit Item'
        }
      },
      async openModal({ isCreate = true, row = {}, onlyInfo = false }) {
        this.onlyInfo = onlyInfo
        this.isCreate = isCreate
        this.setTitle()
        this.row = row
        if (!isCreate) {
          this.typeId = this.row.itemsTypeId
          this.selectType(this.row.itemsTypeId)
        }
        this.$refs.modal.open()
      },
      selectType(value) {
        if (value === '') {
          this.currentTabComponent = this.group[0]
          return
        }
        const selectedItem = this.itemTypeList.find(item => item.id === value);
        this.currentTabComponent = this.group[selectedItem.group]
        this.$nextTick(() => {
          this.$refs.component.openModal({ isCreate: this.isCreate, row: this.row, onlyInfo: this.onlyInfo })
        });
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      closeModal(ref) {
        // if (this.currentTabComponent !== 'Main') {
        //   this.$refs[ref].$refs.form.resetFields()
        // }
        this.typeId = null
        this.currentTabComponent = this.group[0]
      },
    },
  }
</script>